import { render } from "./WebLink.vue?vue&type=template&id=40013a65"
import script from "./WebLink.vue?vue&type=script&lang=js"
export * from "./WebLink.vue?vue&type=script&lang=js"

import "./WebLink.vue?vue&type=style&index=0&id=40013a65&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__